module.exports = __webpack_public_path__ + "static/media/abstract1.e108c06f.jpg";